<template>
  <div
    :class="[
      'mlui-core-card',
      `mlui-core-card--${borderStyle}`,
      {'shadow-sm': !withoutShadow},
      'rounded',
      'p-2',
      backgroundColorClass
    ]"
    v-bind="$attrs">
    <slot />
  </div>
</template>

<script>
/**
 * @deprecated - Use FrontCore/src/views/cards/CoreCard.vue instead
 */
export default {
  props: {
    backgroundColorClass: {
      type: String,
      default: 'tw-bg-core-primary-100',
    },
    borderStyle: {
      type: String,
      default: 'solid',
      validator (value) {
        return ['solid', 'dashed'].includes(value)
      },
    },
    withoutShadow: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>
.mlui-core-card {
    border-width: 1px;
    border-color: var(--core-neutral-cold-80);
}

.mlui-core-card--solid {
    border-style: solid;
}

.mlui-core-card--dashed {
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%23AAAAAAFF' stroke-width='2' stroke-dasharray='6%2c 12' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
}

</style>
